import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerCardInfo } from '../orderDetailsTypes';
import styles from './CustomerInfoCard.module.css';

interface CustomerInfoCardProps {
  info: CustomerCardInfo;
}

export const CustomerInfoCard: React.FC<CustomerInfoCardProps> = ({ info }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Customer Information</h3>
      <p className={styles.name}>{info.name}</p>
      <p className={styles.contact}>{info.contact}</p>

      <div className={styles.row}>
        <p className={styles.label}>Phone</p>
        <p className={styles.value}>{info.phone}</p>
      </div>
      <div className={styles.row}>
        <p className={styles.label}>Email</p>
        <p className={styles.link}>{info.email}</p>
      </div>
      <div className={styles.row}>
        <p className={styles.label}>Location</p>
        <p className={styles.value}>{info.location}</p>
      </div>

      <button
        className={styles.viewBtn}
        onClick={() => info.id && navigate(`/customer-details?id=${info.id}`)}
        disabled={!info.id}
      >
        View Customer Profile
      </button>
    </div>
  );
};
